
export async function DownloadDocument(response, data) {
    try{
        if(!response) {
            console.log('Failed to download file')
        }
        const blob = response.data;
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = data.fileLocationPath;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
    }
    catch(error){
        console.log('Error downloading file: ', error)
    }
}